<template>
   <div>
      <b-row>
         <b-col cols="12" class="mb-2">
            <h3 class="mb-0 text-center">
               Cedente
            </h3>
            <h4 class="mb-0 text-center">
               (Proprietario Atual)
            </h4>
         </b-col>

      </b-row>
      <b-row v-for="cedente in cedentes" :key="cedente.nome">

         <b-col md="12">
            <b-form-group label="Nome" label-for="nomeCedente">
               <b-form-input id="nomeCedente" type="text" :value="cedente.nome" readonly />
            </b-form-group>
         </b-col>

         <b-col md="3">
            <b-form-group label="Telefone Principal*" label-for="telefoneCedente">
               <b-form-input type="text" id="telefoneCedente" :value="cedente.telefone_principal" v-mask="mask"
                  v-model="cedente.telefone_principal" placeholder="(99) 99999-9999" />
            </b-form-group>
         </b-col>

         <b-col md="3">
            <b-form-group label="Telefone Recado*" label-for="telefone2Cedente">
               <b-form-input type="text" id="telefone2Cedente" :value="cedente.telfone_recado" v-mask="mask"
                  v-model="cedente.telfone_recado" placeholder="(99) 99999-9999" />
            </b-form-group>
         </b-col>

         <b-col md="6">
            <b-form-group label="Estado Civil*" label-for="estadoCivilCedente">
               <v-select id="estadoCivilCedente" :clearable="false" v-model="cedente.estadoCivil"
                  :options="optionsEstadoCivil" @input="cedente.estadoCivil" :value="cedente.estadoCivil"
                  :getOptionLabel="customerContracts => customerContracts.text" :searchable="true">
                  <template #open-indicator="{ attributes }">
                     <feather-icon v-bind="attributes" icon="ChevronDownIcon" size="20" class="mr-1" />
                  </template>
               </v-select>
            </b-form-group>
         </b-col>

         <b-col md="6">
            <b-form-group label="Profissão" label-for="profissaoCedente">
               <v-select id="profissaoCedente" :clearable="false" v-model="cedente.profissao"
                  :options="opcoesProfissao" @input="cedente.profissao" :value="cedente.profissao"
                  :getOptionLabel="customerContracts => customerContracts.descricao" :searchable="true">
                  <template #open-indicator="{ attributes }">
                     <feather-icon v-bind="attributes" icon="ChevronDownIcon" size="20" class="mr-1" />
                  </template>
               </v-select>
            </b-form-group>
         </b-col>

         <b-col md="6">
            <b-form-group label="Naturalidade" label-for="naturalidadeCedente">
               <v-select id="naturalidadeCedente" :clearable="false" v-model="cedente.naturalidade"
                  :options="opcoesNaturalidade" @input="cedente.naturalidade" :value="cedente.naturalidade"
                  :getOptionLabel="customerContracts => customerContracts.descricao" :searchable="true">
                  <template #open-indicator="{ attributes }">
                     <feather-icon v-bind="attributes" icon="ChevronDownIcon" size="20" class="mr-1" />
                  </template>
               </v-select>
            </b-form-group>
         </b-col>

         <b-col md="12">
            <b-form-group label="Chave Pix para Autenticação" label-for="chavePix"
               description="Chave pix utilizada para realizar assinatura do documento, a chave obrigatóriamente deve ser apenas E-mail, Celular ou CPF."
               :invalid-feedback="cedente.mensagemErro" :state="cedente.chave_pix > 0">
               <b-form-input id="chavePix" type="text" v-model="cedente.chave_pix" :value="cedente.chave_pix"
                  :state="cedente.state" trim />
            </b-form-group>
         </b-col>

         <b-col md="12">
            <b-form-group label="Documento de Identidade" label-for="docIdentidade"
               description="Os documentos aceitos são: RG e CPF, CNH, CRNM, RNE"
               :invalid-feedback="cedente.mensagemErro" :state="cedente.chave_pix > 0">
               <b-input-group>
                  <b-form-file v-model="cedente.docIdentidade" :state="Boolean(cedente.docIdentidade)"
                     placeholder="Escolha um arquivo ou arraste-o aqui..." drop-placeholder="Arraste o arquivo aqui..."
                     browse-text="Procurar"></b-form-file>
                  <b-input-group-append>
                     <b-button size="sm"
                        variant="primary"
                        icon="feather icon-info"
                        class="btn-tour-next" v-b-modal.modal-preview target="_blank" :disabled="!cedente.docIdentidade">
                        <b-icon-eye></b-icon-eye>
                     </b-button>
                     <b-button size="sm"
                        variant="primary"
                        icon="feather patch-question"
                        class="btn-tour-next"
                        id="duvida-identidade">
                        <b-icon-patch-question></b-icon-patch-question>
                     </b-button>
                     <b-tooltip target="duvida-identidade" placement="bottom">
                        <p>Os documentos aceitos são:</p> 
                        <p><strong>- RG e CPF</strong> (legíveis e completos);</p>
                        <p><strong>- CNH</strong> (desde que não vencida);</p>
                        <p><strong>- CRNM</strong> (Carteira de Registro Nacional Migratório) ou <strong>RNE</strong> (Registro Nacional de Estrangeiro).</p>
                     </b-tooltip>
                  </b-input-group-append>
               </b-input-group>
            </b-form-group>
            <b-modal
               id="modal-preview"
               :title="urlArquivo(cedente.docIdentidade) ? cedente.docIdentidade.name : ' '"
               centered
               ok-only
               ok-title="Fechar"
               modal-class="modal-fullscreen"
               size="xl"
            >
               
               <iframe
                  v-if="urlArquivo(cedente.docIdentidade)"
                  :src="urlArquivo(cedente.docIdentidade)"
                  class="iframe-preview"
                  frameborder="0"
               >
               Seu navegador não suporta a visualização deste tipo de arquivo.
               </iframe>

               <p v-else>Não foi possível gerar a visualização.</p>

            </b-modal>
         </b-col>

         <b-col md="12">
            <b-form-group label="Documento que comprove o Estado Civil" label-for="docEstadoCivil"
               description="Os documentos aceitos são: RG e CPF, CNH, CRNM, RNE"
               :invalid-feedback="cedente.mensagemErro">
               <b-input-group>
                  <b-form-file v-model="cedente.docEstadoCivil" :state="Boolean(cedente.docEstadoCivil)"
                     placeholder="Escolha um arquivo ou arraste-o aqui..." drop-placeholder="Arraste o arquivo aqui..."
                     browse-text="Procurar"></b-form-file>
                  <b-input-group-append>
                     <b-button size="sm"
                        variant="primary"
                        class="btn-tour-next" v-b-modal.modal-preview-estado-civil target="_blank" :disabled="!cedente.docEstadoCivil">
                        <b-icon-eye></b-icon-eye>
                     </b-button>
                     <b-button size="sm"
                        variant="primary"
                        icon="feather patch-question"
                        class="btn-tour-next"
                        id="duvida-estado-civil">
                        <b-icon-patch-question></b-icon-patch-question>
                     </b-button>
                     <b-tooltip target="duvida-estado-civil" placement="bottom">
                        <p>Os documentos aceitos, conforme estado civil, são:</p> 
                        <p><strong>- Certidão de Nascimento ATUALIZADA</strong> em cartório <strong>(até 90 dias)</strong>: Se solteiro.</p>
                        <p><strong>- Certidão de Casamento:</strong> Se casado.</p>
                        <p><strong>Certidão de Casamento ATUALIZADA</strong> em cartório <strong>(até 90 dias): </strong>Se <strong>divorciado ou viúvo(a).</strong> Caso seja <strong>viúvo(a)</strong>, anexar a <strong>Certidão de Óbito</strong> do(a) cônjuge falecido.</p>
                        <p><strong>- Declaração de União Estável:</strong> Se declarado, em cartório.</p>
                     </b-tooltip>
                  </b-input-group-append>
               </b-input-group>
            </b-form-group>
            <b-modal
               id="modal-preview-estado-civil"
               :title="urlArquivo(cedente.docEstadoCivil) ? cedente.docEstadoCivil.name : ' '"
               centered
               ok-only
               ok-title="Fechar"
               modal-class="modal-fullscreen"
               size="xl"
            >
               
               <iframe
                  v-if="urlArquivo(cedente.docEstadoCivil)"
                  :src="urlArquivo(cedente.docEstadoCivil)"
                  class="iframe-preview"
                  frameborder="0"
               >
               Seu navegador não suporta a visualização deste tipo de arquivo.
               </iframe>

               <p v-else>Não foi possível gerar a visualização.</p>

            </b-modal>
         </b-col>

         <b-col md="12">
            <div class="divider"></div>
         </b-col>
      </b-row>
   </div>
</template>

<style scoped>
.centro {
   display: flex;
   align-items: center;
   justify-content: center;
}

.divider {
   background: #d0d2d6;
   width: 100%;
   height: 1px;
   margin-bottom: 2%;
   margin-top: 2%;
}

/* ::v-deep é necessário para forçar o estilo
  dentro dos componentes filhos do BModal.
*/

/* 1. Força o DIÁLOGO a ocupar 100% da tela 
   Usamos !important para garantir a prioridade
*/
.modal-fullscreen ::v-deep .modal-dialog {
  max-width: none !important;
  width: 100vw !important;
  height: 100vh !important;
  margin: 0 !important;
}

/* 2. Força o CONTEÚDO a preencher o diálogo */
.modal-fullscreen ::v-deep .modal-content {
  height: 100% !important;
  border-radius: 0 !important;
  display: flex;
  flex-direction: column;
}

/* 3. Força o CORPO (body) a se expandir */
.modal-fullscreen ::v-deep .modal-body {
  flex-grow: 1 !important;
  padding: 0 !important;
  overflow: hidden !important;
}

/* Esta classe está no nosso template, 
  então NÃO precisa de ::v-deep.
*/
.iframe-preview {
  width: 100%;
  height: 100%;
  border: none;
}
</style>

<script>
import vSelect from 'vue-select'
import {
   BRow,
   BCol,
   BFormGroup,
   BFormInput,
   BFormFile,
   BInputGroup,
   BInputGroupAppend,
   BButton,
   BIconEye,
   BIconPatchQuestion,
   BModal,
   BTooltip
} from 'bootstrap-vue'

export default {
   props: {
      cedentes: {
         type: Array,
         required: true
      },
      opcoesNaturalidade: {
         type: Array,
         required: true
      },
      opcoesProfissao: {
         type: Array,
         required: true
      },
      optionsEstadoCivil: {
         type: Array,
         required: true
      }
   },
   name: 'Cedentes',
   components: {
      BRow,
      vSelect,
      BCol,
      BFormGroup,
      BFormInput,
      BFormFile,
      BInputGroupAppend,
      BButton,
      BInputGroup,
      BIconEye,
      BModal,
      BIconPatchQuestion,
      BTooltip
   },

   data() {
      return {
         mask: ['(', /\d/, /\d/, ') ', /\d/, ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
         maskCpf: [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
         docIdentidade: null,
         urlPreview: null
      }
   },
   methods: {
      urlArquivo(arquivo) {
         if (arquivo){
            let url = URL.createObjectURL(arquivo)
            return url
         }
      }
   },

   computed: {
   },
}
</script>
